module.exports = __webpack_public_path__ + "img/4s.4fcacdc4.png";